/* tslint:disable */
import {
  Player,
  Game
} from '../index';

declare var Object: any;
export interface PlayerMetaInterface {
  "key": string;
  "value": any;
  "id"?: any;
  "playerId"?: any;
  "gameId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  player?: Player;
  game?: Game;
}

export class PlayerMeta implements PlayerMetaInterface {
  "key": string;
  "value": any;
  "id": any;
  "playerId": any;
  "gameId": any;
  "createdAt": Date;
  "updatedAt": Date;
  player: Player;
  game: Game;
  constructor(data?: PlayerMetaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerMeta`.
   */
  public static getModelName() {
    return "PlayerMeta";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerMeta for dynamic purposes.
  **/
  public static factory(data: PlayerMetaInterface): PlayerMeta{
    return new PlayerMeta(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerMeta',
      plural: 'player-metas',
      path: 'player-metas',
      idName: 'id',
      properties: {
        "key": {
          name: 'key',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
      }
    }
  }
}
